import styled from 'styled-components'

export const Wrapper = styled.div`
   
    display:grid;
    margin: 0 auto;
    
    background-color: var(--lightGrey);
    justify-content:space-around;
    align-items:center;
   
    z-index: 1000;

    h1 {
        color: var(--medGrey);

        @media screen and (max-width: 768px) {
            font-size: var(--fontBig);
        }

    }
`;

export const Content = styled.div`
    display: grid;
    grid-template-columns: auto auto auto; 
    grid-auto-flow: column;
    grid-gap: 0.5rem;
`;
